<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <md-section md="development.md" />
        <deployment-checklist :class="['mt-8']" />
      </flex-col>
    </flex>
    <all-section-blocks :title="true" :tooltip="false" />
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageDevelopment',
  mixins: [
    methods
  ]
}
</script>



// WEBPACK FOOTER //
// src/pages/getting-started/development.vue